module.exports = __webpack_public_path__ + "static/IMG_1568-2f0a82c68e16eb7eee5826efd6f279b8.jpg";